/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Transfers_To_ConfirmInputs */

const en_queue_transfers_to_confirm = /** @type {(inputs: Queue_Transfers_To_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfer orders to confirm`)
};

/**
* | output |
* | --- |
* | "Transfer orders to confirm" |
*
* @param {Queue_Transfers_To_ConfirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_transfers_to_confirm = /** @type {((inputs?: Queue_Transfers_To_ConfirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Transfers_To_ConfirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_transfers_to_confirm(inputs)
});